
/**
 * @fileOverview Profile Controller Module
 * @Author: Pat
 * @modified 02/02/2015
 *
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/ProfileController',['require','jquery','lib/Util'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');


        var ProfileController = function ($element) {
        	this.trigger = $element;
        	this.target = '';
        	this.closeLink = '';

			this.init();
        };

		ProfileController.prototype.init = function(){
			$debug('Initializing profile link...', 'MMMProfileController');

			// If the href attribute is a ID selector, set the target and close link
			if(this.trigger.attr('href').indexOf('#') === 0){
				// If the href is ###auth###, then this does not open the menu and will be handled in setupHandlers
				if(this.trigger.attr('href') !== '###auth###' && $(this.trigger.attr('href')).length > 0){
					this.target = $(this.trigger.attr('href'));
					this.closeLink = this.target.find('.js-closeLink');
				}
			}

			this.setupHandlers();
		};

		ProfileController.prototype.setupHandlers = function(){
			var self = this;

			this.trigger.on('click', function(event){
				if(self.trigger.attr('href') === '###auth###'){
					event.preventDefault();
					self.toggleAuth();
				} else if(self.target.length > 0){
					event.preventDefault();
					if($(this).hasClass('MMM--isActive')){
						self.closeDrawer(event, $(this));
					} else{
						self.openDrawer(event, $(this));
					}
				} else{
					// If the href is not a reference to the drawer or the ###auth### placeholder, follow the URL normally
					return true;
				}
			});

			if(this.closeLink.length > 0){
				this.closeLink.on('click', function(event){
					self.closeDrawer(event, self.trigger);
				});
			}

			return this;
		};

		ProfileController.prototype.toggleAuth = function(){
			var authUrl = location.href;

			$debug('Toggling to the authorized URL:', 'MMMProfileController');

			// Replace the URL with the authenticated directory
			if(authUrl.indexOf('/3M/') > -1){
				authUrl = authUrl.replace('/3M/', '/my3M/');
			} else if(authUrl.indexOf('/portal/') > -1){
				authUrl = authUrl.replace('/portal/', '/myportal/');
			}

			$debug(authUrl, 'MMMProfileController');
			// If the authenticated URL is different from the current URL, open it
			if(authUrl !== location.href){
				window.location.href = authUrl;
			}

			return this;
		};

		ProfileController.prototype.openDrawer = function(event, $element){
			$element.addClass('MMM--isActive');
			this.target.addClass('MMM--isActive').css({top: $element.offset().top + $element.outerHeight()});

			return this;
		};

		ProfileController.prototype.closeDrawer = function(event, $element){
			$element.removeClass('MMM--isActive');
			this.target.removeClass('MMM--isActive');

			return this;
		};

        return ProfileController;
    });

}(MMMRequire));